// Actions for the conference-ring inbound call pipeline (voice_ring).
// Ring events arrive over V3::CallsChannel; the live Twilio Call object is
// owned by @/api/calls/call-ring (non-serializable), so Redux holds display
// state only.

export enum CallTypes {
  RING_RECEIVED = 'app/calls/RING_RECEIVED',
  RING_STOPPED = 'app/calls/RING_STOPPED',
  RING_DISMISSED = 'app/calls/RING_DISMISSED',
  CLAIM_STARTED = 'app/calls/CLAIM_STARTED',
  CLAIM_WON = 'app/calls/CLAIM_WON',
  CLAIM_LOST = 'app/calls/CLAIM_LOST',
  CALL_ENDED = 'app/calls/CALL_ENDED',
  MUTE_TOGGLED = 'app/calls/MUTE_TOGGLED',
}

// Matches the call_ring broadcast payload built in app/services/calls/ring_service.rb
export interface RingPayload {
  call_id: string;
  ticket_uuid: string;
  contact_name: string;
  contact_phone: string;
  to_number: string;
  started_at: number;
  timeout_seconds: number;
}

// declined: this agent declined, so it only reaches their own browsers
export type RingStopReason = 'answered' | 'canceled' | 'timeout' | 'declined';

export const ringReceived = ({ ring }: { ring: RingPayload }) => ({
  type: CallTypes.RING_RECEIVED,
  payload: { ring },
});

export const ringStopped = ({ callId, reason, answeredByName }: {
  callId: string;
  reason: RingStopReason;
  answeredByName?: string;
}) => ({
  type: CallTypes.RING_STOPPED,
  payload: { callId, reason, answeredByName },
});

// Hides the prompt in this browser right away; declineCall (@/api/calls/call-ring)
// tells the server, which clears the agent's other tabs too
export const ringDismissed = ({ callId }: { callId: string }) => ({
  type: CallTypes.RING_DISMISSED,
  payload: { callId },
});

export const claimStarted = ({ callId }: { callId: string }) => ({
  type: CallTypes.CLAIM_STARTED,
  payload: { callId },
});

export const claimWon = ({ callId, contactName, contactPhone }: {
  callId: string;
  contactName: string;
  contactPhone: string;
}) => ({
  type: CallTypes.CLAIM_WON,
  payload: { callId, contactName, contactPhone, connectedAt: Date.now() },
});

export const claimLost = ({ callId }: { callId: string }) => ({
  type: CallTypes.CLAIM_LOST,
  payload: { callId },
});

export const callEnded = ({ callId }: { callId: string }) => ({
  type: CallTypes.CALL_ENDED,
  payload: { callId },
});

export const muteToggled = ({ muted }: { muted: boolean }) => ({
  type: CallTypes.MUTE_TOGGLED,
  payload: { muted },
});
